export enum Module {
  ADMIN = "admin",
  COLLECTION = "collection",
  ECONOMY = "economy",
  INPUT_OUTPUT = "io",
  REPORTS = "Reports",
  COMMUNICATION = "usc",
  OPERATIONS = "operations",
  COURT_INVOICE = "ci",
  WORKFLOW = "WorkflowModule",
}

export const MENU_ORDER: Record<string, number> = {
  [Module.INPUT_OUTPUT]: 1,
  [Module.ECONOMY]: 2,
  [Module.COURT_INVOICE]: 3,
  [Module.REPORTS]: 4,
  [Module.COMMUNICATION]: 5,
  [Module.OPERATIONS]: 6,
  [Module.WORKFLOW]: 7,
  [Module.ADMIN]: 999,
};
